import React from 'react';
import { useOrganization } from '../../contexts/OrganizationContext';
import { TopBar } from '../../components/TopBar/TopBar';
import './LogoutAgreementView.css';

interface LogoutAgreementViewProps {
  onBack: () => void;
  onApplyLogout: () => void;
}

/**
 * 注销协议页面
 */
export const LogoutAgreementView: React.FC<LogoutAgreementViewProps> = ({ onBack, onApplyLogout }) => {
  const { organization } = useOrganization();
  const logoutAgreement = organization?.logoutAgreement || '';

  return (
    <div className="logout-agreement-view">
      <TopBar title="注销账号" showBack onBack={onBack} />
      
      <div className="logout-agreement-content">
        {logoutAgreement ? (
          <div 
            className="logout-agreement-html" 
            dangerouslySetInnerHTML={{ __html: logoutAgreement }}
          />
        ) : (
          <div className="logout-agreement-empty">暂无注销协议内容</div>
        )}
      </div>

      <div className="logout-agreement-footer">
        <button className="logout-apply-btn" onClick={onApplyLogout}>
          申请注销
        </button>
      </div>
    </div>
  );
};

